module.exports = __webpack_public_path__ + "img/figure0-offer4.a9a81087.png";